export const curriculum = {
  state: {
    curriculums: []
  },
  mutations: {
    addCurriculum (state, payload) {
      state.curriculums = state.curriculums.concat(payload)
    },
    setCurriculums (state, payload) {
      state.curriculums = payload
    }
  },
  actions: {
    addCurriculum ({ commit }, payload) {
      return commit('addCurriculum', payload)
    },
    setCurriculums ({ commit }, payload) {
      return commit('setCurriculums', payload)
    }
  },
  getters: {
    getCurriculums (state) {
      return state.curriculums
    }
  }
}
